import React from 'react';
import styled from 'styled-components';
import { theme } from '../styles/theme';
import { SharedLayout } from '../components/layout/SharedLayout';

const PageWrapper = styled.div`
  min-height: 60vh;
`;

const Container = styled.div`
  max-width: ${theme.breakpoints.wide};
  margin: 0 auto;
  padding: 0 ${theme.spacing.xl};

  @media (max-width: ${theme.breakpoints.tablet}) {
    padding: 0 ${theme.spacing.md};
  }
`;

const PageTitle = styled.h1`
  text-align: center;
  margin-bottom: ${theme.spacing['2xl']};
`;

export const BacktestAnnuities: React.FC = () => {
  return (
    <SharedLayout>
      <PageWrapper>
        <Container>
          <PageTitle>Backtest Annuities with AI</PageTitle>
          <p>Use our AI-powered tool to analyze historical annuity performance...</p>
        </Container>
      </PageWrapper>
    </SharedLayout>
  );
};